import { IGif } from "@/common/api/services/types";
import { useMemo } from "react";
import { useUserStore } from "@/common/store";

export const useFilteredFeed = (gifs: IGif[]) => {
  const user = useUserStore((state) => state.currentUser);

  const filteredGifs = useMemo(() => {
    return gifs.filter((gif) => {
      if (gif.cta) {
        return true;
      }

      if (!user || !user.blockedTags) {
        return true;
      }

      return !gif.tags.some((tag) => user.blockedTags?.includes(tag));
    });
  }, [gifs, user]);

  return {
    gifs: filteredGifs
  };
};
